// extracted by mini-css-extract-plugin
module.exports = {"link":"link__1fXO_","subtitle":"subtitle__1nLvW","left":"left__3pl-g","right":"right__tZQWt","image":"image__2aEsG","buttons":"buttons__1lKQb"};